import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moveToTop: {
		id: 'jira-navigation-apps-sidebar-nav4-projects-customise-order.move-menu.move-to-top-action',
		defaultMessage: 'Move to top',
		description: 'Dropdown menu item to move the project to the top of the list',
	},
	moveUp: {
		id: 'jira-navigation-apps-sidebar-nav4-projects-customise-order.move-menu.move-up-action',
		defaultMessage: 'Move up',
		description: 'Dropdown menu item to move the project one position towards the top of the list',
	},
	moveDown: {
		id: 'jira-navigation-apps-sidebar-nav4-projects-customise-order.move-menu.move-down-action',
		defaultMessage: 'Move down',
		description:
			'Dropdown menu item to move the project one position towards the bottom of the list',
	},
	moveToBottom: {
		id: 'jira-navigation-apps-sidebar-nav4-projects-customise-order.move-menu.move-to-bottom-action',
		defaultMessage: 'Move to bottom',
		description: 'Dropdown menu item to move the project to the bottom of the list',
	},
	moveInSidebarMenu: {
		id: 'jira-navigation-apps-sidebar-nav4-projects-customise-order.move-menu.move-in-sidebar-menu',
		defaultMessage: 'Move in sidebar',
		description: 'Dropdown menu item for options to move the project in the sidebar',
	},
});
